// extracted by mini-css-extract-plugin
export default {"Container":"SeminarImages_Container__OCVhu","Images":"SeminarImages_Images__37HY7","Image":"SeminarImages_Image__b+hUA"};